import { render } from "./tech.vue?vue&type=template&id=2a6891ab&scoped=true"
import script from "./tech.vue?vue&type=script&lang=jsx"
export * from "./tech.vue?vue&type=script&lang=jsx"

import "./tech.vue?vue&type=style&index=0&id=2a6891ab&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6891ab"]])

export default __exports__